import React, { useState, useEffect } from 'react';
import './GoogleProfileCompletionModal.css';

const GoogleProfileCompletionModal = ({ open, onClose, onSubmit, missingFields, initialValues = {} }) => {
  const [form, setForm] = useState({
    phone: initialValues.phone || '',
    pincode: initialValues.pincode || '',
    stageName: initialValues.stageName || '',
  });

  useEffect(() => {
    setForm({
      phone: initialValues.phone || '',
      pincode: initialValues.pincode || '',
      stageName: initialValues.stageName || '',
    });
  }, [initialValues, open]);

  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const primaryColor = 'white';
  const secondaryColor = '#4a5fc1';
  const lightBg = 'rgba(45, 66, 153, 0.08)';

  useEffect(() => {
    if (open) {
      setIsVisible(true);
    } else {
      // Delay hiding to allow animation to complete
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!open && !isVisible) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSubmit(form);
    setLoading(false);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 3000,
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.3s ease-in-out',
      padding: '16px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #0F0F23 0%, #1E1B4B 100%)',
        borderRadius: '20px',
        padding: '32px 28px',
        width: '100%',
        maxWidth: '420px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
        opacity: isVisible ? 1 : 0,
        border: '1px solid rgba(255, 255, 255, 0.4)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '24px'
        }}>
          <h2 style={{
            margin: 0,
            color: 'white',
            fontFamily: "Gilroy-semiBold",
            fontWeight: 700,
            fontSize: '24px'
          }}>
            Complete Your Profile
          </h2>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: 'white',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseOut={(e) => {
              // e.currentTarget.style.background = 'white';
              e.currentTarget.style.transform = 'scale(1)';
            }}>
            &times;
          </button>
        </div>

        <p style={{
          color: '#dadada',
          fontSize: '15px',
          lineHeight: '1.5',
          marginTop: '0',
          marginBottom: '24px',
          fontFamily: "Gilroy-semiBold"
        }}>
          Please provide the following information to complete your profile:
        </p>

        <form onSubmit={handleSubmit}>
          {missingFields.includes('phone') && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#dadada',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "Gilroy-semiBold"
              }}>
                Phone Number
              </label>
              <input
                name="phone"
                type="tel"
                placeholder="Enter your 10-digit phone number"
                value={form.phone}
                onChange={handleChange}
                required
                style={{
                  color: "white",
                  width: '100%',
                  padding: '14px 16px',
                  borderRadius: '12px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  fontSize: '16px',
                  outline: 'none',
                  fontFamily: "Gilroy-semiBold",
                  boxSizing: 'border-box',
                  transition: 'border 0.2s, box-shadow 0.2s',
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'rgba(108, 43, 217, 0.6)';
                  e.target.style.background = 'rgba(108, 43, 217, 0.1)';
                  e.target.style.boxShadow = '0 0 0 2px rgba(66, 133, 244, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'gray';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          {missingFields.includes('pincode') && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#dadada',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "Gilroy-semiBold"
              }}>
                Pincode
              </label>
              <input
                name="pincode"
                type="text"
                placeholder="Enter your pincode"
                value={form.pincode}
                onChange={handleChange}
                required
                style={{
                  color: "white",
                  width: '100%',
                  padding: '14px 16px',
                  borderRadius: '12px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  fontSize: '16px',
                  fontFamily: "Gilroy-semiBold",
                  boxSizing: 'border-box',
                  transition: 'border 0.2s, box-shadow 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'rgba(108, 43, 217, 0.6)';
                  e.target.style.background = 'rgba(108, 43, 217, 0.1)';
                  e.target.style.boxShadow = '0 0 0 2px rgba(66, 133, 244, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'gray';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          {missingFields.includes('stageName') && (
            <div style={{ marginBottom: '28px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#dadada',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "Gilroy-semiBold"
              }}>
                Stage Name
              </label>
              <input
                name="stageName"
                type="text"
                placeholder="Enter your stage name"
                value={form.stageName}
                onChange={handleChange}
                required
                style={{
                                    color:"white",
                  width: '100%',
                  padding: '14px 16px',
                  borderRadius: '12px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  fontSize: '16px',
                  fontFamily: "Gilroy-semiBold",
                  boxSizing: 'border-box',
                  transition: 'border 0.2s, box-shadow 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'rgba(108, 43, 217, 0.6)';
                  e.target.style.background = 'rgba(108, 43, 217, 0.1)';
                  e.target.style.boxShadow = '0 0 0 2px rgba(66, 133, 244, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'gray';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          <div style={{
            display: 'flex',
            gap: '12px'
          }}>
            <button
              className='SaveAndContinue'
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: '14px 20px',
                borderRadius: '12px',
                background: loading ? '#ccc' : '#4338CA',
                color: '#fff',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Gilroy-semiBold",
                border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s, transform 0.1s',
                // boxShadow: loading ? 'none' : '0 4px 12px rgba(66, 133, 244, 0.3)'
              }}
            // onMouseOver={(e) => {
            //   if (!loading) {
            //     e.target.style.background = '#3367d6';
            //   }
            // }}
            // onMouseOut={(e) => {
            //   if (!loading) {
            //     e.target.style.background = '#4285f4';
            //   }
            // }}
            // onMouseDown={(e) => {
            //   if (!loading) {
            //     e.target.style.transform = 'scale(0.98)';
            //   }
            // }}
            // onMouseUp={(e) => {
            //   if (!loading) {
            //     e.target.style.transform = 'scale(1)';
            //   }
            // }}
            >
              {loading ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg style={{ width: '20px', height: '20px', marginRight: '8px' }} viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeDasharray="32" strokeDashoffset="0">
                      <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
                    </circle>
                  </svg>
                  Saving...
                </span>
              ) : 'Save & Continue'}
            </button>

            <button
              className="cancel-btn"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GoogleProfileCompletionModal;